interface CartaoNumeroProps {
  rotulo: string;
  valor: string;
  icone?: string;
  destaque?: boolean;
}

// Cartão de número grande. O valor nunca quebra linha: a fonte reduz no celular.
export default function CartaoNumero({ rotulo, valor, icone, destaque = false }: CartaoNumeroProps) {
  return (
    <div
      className={`rel-cartao flex h-full min-h-[92px] flex-col justify-between rounded-2xl px-4 py-4 ${
        destaque
          ? 'bg-primary-500'
          : 'border border-background-200 bg-white shadow-[0_1px_3px_rgba(16,24,40,0.04)]'
      }`}
    >
      <div className="flex items-center gap-2">
        {icone && (
          <span
            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${
              destaque ? 'bg-white/20 text-white' : 'bg-background-100 text-foreground-500'
            }`}
          >
            <i className={`${icone} text-sm`} />
          </span>
        )}
        <span
          className={`text-[12px] font-medium ${destaque ? 'text-white/80' : 'text-foreground-500'}`}
        >
          {rotulo}
        </span>
      </div>
      <p
        className={`mt-2 whitespace-nowrap text-[clamp(1.05rem,5vw,1.7rem)] font-extrabold leading-none tabular-nums ${
          destaque ? 'text-white' : 'text-foreground-950'
        }`}
      >
        {valor}
      </p>
    </div>
  );
}